// ignore-string-localization
import styled, { css } from 'styled-components';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { cssColorValue, PopoverNavigationItem, Type, screenXsMax, screenSmMin, screenLgMin, screenSmMax, screenMdMin, screenMdMax, spacer4, spacer8, spacer12, spacer16, spacer20, spacer32, spacer40 } from '@spotify-internal/encore-web';
import { ButtonPrimaryAsLink, getLinkStyle } from '../../ui';
var logoAreaWidth = '325px';
export var StyledListItemWithMargin = styled.li.withConfig({
  displayName: "NavBarstyles__StyledListItemWithMargin",
  componentId: "d9sx3c-0"
})(["margin-inline-start:", ";& > a:focus > div{border-color:", " !important;}"], spacer12, function (props) {
  return props.color;
});
export var StyledListItemNoMargin = styled.li.withConfig({
  displayName: "NavBarstyles__StyledListItemNoMargin",
  componentId: "d9sx3c-1"
})(["& > a:focus > div{border-color:", " !important;}"], function (props) {
  return props.color;
});
export var LogoArea = styled.div.withConfig({
  displayName: "NavBarstyles__LogoArea",
  componentId: "d9sx3c-2"
})(["width:", ";@media (max-width:", "){height:28px;}@media (min-width:", "){height:36px;}"], logoAreaWidth, screenSmMax, screenMdMin);
export var MenuLink = styled(Type).attrs({
  weight: Type.bold
}).withConfig({
  displayName: "NavBarstyles__MenuLink",
  componentId: "d9sx3c-3"
})([""]);
export var MenuCategory = styled(Type).attrs({
  weight: Type.bold
}).withConfig({
  displayName: "NavBarstyles__MenuCategory",
  componentId: "d9sx3c-4"
})(["svg{margin-left:", ";}"], spacer8);
export var ClaimButton = styled(ButtonPrimaryAsLink).attrs({
  buttonSize: 'sm'
}).withConfig({
  displayName: "NavBarstyles__ClaimButton",
  componentId: "d9sx3c-5"
})(["white-space:nowrap;"]);
export var LoginButton = styled(ButtonPrimaryAsLink).attrs({
  buttonSize: 'sm'
}).withConfig({
  displayName: "NavBarstyles__LoginButton",
  componentId: "d9sx3c-6"
})(["white-space:nowrap;"]);
export var NavBarWrapper = styled.header.withConfig({
  displayName: "NavBarstyles__NavBarWrapper",
  componentId: "d9sx3c-7"
})(["position:fixed;top:0;width:100%;z-index:1000;background:", ";color:", ";display:flex;align-items:center;justify-content:flex-start;", " ul,ol{list-style:none;padding-left:0;li{height:100%;div:first-child{height:100%;}}}li{line-height:20px;}", ",", ",", ",", "{&,a,a:visited,button{color:", ";vertical-align:top;", "}}", " button{color:", ";&:hover{color:", ";}}", " a{svg{fill:", ";}}", ":not(:disabled){background:transparent;border:1px solid ", ";color:", ";&:hover:not(:disabled){color:", ";background:transparent;}}", ":not(:disabled){background:", ";border:1px solid ", ";color:", ";&:hover:not(:disabled),:focus{color:", ";background:", ";}}@media (max-width:", "){padding:", " ", ";}@media (min-width:", "){padding:", " ", ";}ul ul{flex-flow:column nowrap;}", "{a{&,&:focus,&:focus:not(:disabled),&:hover,&:active,&:active:not(:disabled),&:visited{color:", " !important;padding-top:", ";padding-bottom:0;&:last-child{padding-bottom:", ";}}}}"], function (props) {
  return props.isScrolling ? props.customBackground || props.theme.nav.background : 'transparent';
}, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, function (_ref) {
  var bleed = _ref.bleed;
  return !bleed && css(["background:", ";+ main{padding-top:66px;}@media (max-width:", "){+ main{padding-top:48px;}}"], function (props) {
    return props.theme.nav.background;
  }, screenXsMax);
}, MenuLink, MenuCategory, ClaimButton, LoginButton, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, function (props) {
  return getLinkStyle(props);
}, MenuCategory, function (props) {
  return hexToRgba(props.customTextColor || props.theme.nav.text, 0.75);
}, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, LogoArea, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, LoginButton, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, ClaimButton, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, function (props) {
  return props.customBackground || props.theme.nav.background;
}, function (props) {
  return props.customBackground || props.theme.nav.background;
}, function (props) {
  return props.customTextColor || props.theme.nav.text;
}, screenXsMax, spacer8, spacer12, screenSmMin, spacer20, spacer40, PopoverNavigationItem, cssColorValue('textBase'), spacer4, spacer4);
export var LinksArea = styled.nav.withConfig({
  displayName: "NavBarstyles__LinksArea",
  componentId: "d9sx3c-8"
})(["direction:ltr;flex:1;ul{display:flex;flex-flow:row nowrap;justify-content:center;padding:0;margin:auto;li{margin-right:", ";@media (min-width:", "){margin-right:", ";}}}#menu-links{padding:0 124px 0 0;}@media (max-width:", "){display:none;}"], spacer16, screenLgMin, spacer32, screenMdMax);
export var ActionsArea = styled.div.withConfig({
  displayName: "NavBarstyles__ActionsArea",
  componentId: "d9sx3c-9"
})(["width:max-content;height:", ";ul{display:flex;flex-flow:row nowrap;padding:0;}@media (max-width:", "){display:none;}"], spacer32, screenMdMax);
export var MenuButtonArea = styled.div.withConfig({
  displayName: "NavBarstyles__MenuButtonArea",
  componentId: "d9sx3c-10"
})(["flex:1;text-align:right;@media (min-width:", "){display:none;}"], screenMdMax);